import { colors } from 'config/themes/colors';
import styled, { css } from 'styled-components';
import { palette } from 'styled-theme';

const breakAside = palette('mobile', 0);
const scaling125 = palette('mobile', 2);
const hideMenu = palette('mobile', 1);
export const transitionDuration = 250;

const collapsedAddButton = css`
  .ant-menu-item.item-highlight {
    overflow: hidden;
    margin-block: 4px 12px;

    .ant-menu-title-content {
      overflow: hidden;
    }

    a {
      overflow: hidden;
      margin-left: -12px;
    }

    i.ion-android-add {
      margin-right: 60px;
      &:before {
        padding: 9px 12px;
        background: ${colors.fuchsia[600]};
        border-radius: 6px;
        color: white;
      }
    }
  }
`;

const collapsedAddButtonTransition = css`
  .ant-menu-item.item-highlight {
    a,
    i.ion-android-add,
    i.ion-android-add:before {
      transition: all ${transitionDuration}ms ease-in-out;
    }
  }
`;

const LayoutWrapper = styled.div`
  display: block;
  width: 100%;
  height: 100%;
  background: ${palette('background', 10)};
  & .ant-menu {
    margin-top: 35px;
    font-family: 'Roboto';
    background-color: transparent;
    &.ant-menu-light .ant-menu-item:active,
    &.ant-menu-light .ant-menu-submenu:active,
    &.ant-menu-light .ant-menu-submenu-title:active {
      background-color: transparent;
    }
    .ant-menu-submenu {
      margin-block: 0;
    }
    .ant-menu-item,
    .ant-menu-submenu {
      padding: ${palette('padding', 0)};
      text-overflow: clip;
      transition-duration: 250ms;
      transition-property: all;
      transition-timing-function: ease-out;
      transform: translateX(0px);
      background-color: transparent;
      color: ${palette('foreground', 2)};

      .ant-menu-submenu-title {
        padding-left: 0px !important;
        margin-block: 4px;
        color: ${palette('foreground', 2)};
        background-color: transparent;
      }
      .ant-menu-submenu-arrow {
        color: ${palette('foreground', 2)};
      }
      button {
        background: transparent;
        padding: 0px;
        border: 0;
        /* display: block; */
        width: 100%;
        text-align: left;
        &:hover {
          cursor: pointer;
        }
      }
      a,
      button {
        color: ${palette('foreground', 2)};
        font-size: 14px;
        font-weight: 500;
        i,
        svg {
          display: inline-block;
          font-size: 19px;
          margin: 0px 16px 0px 10px;
          width: 15px;
          line-height: 23px;
          vertical-align: middle;
        }
        &:hover {
          color: ${palette('foreground', 5)};
        }
      }
      &:hover {
        background-color: transparent;
      }
      &:active,
      .ant-menu-submenu:active,
      .ant-menu-submenu-title:active {
        transform: translateX(8px);
        a,
        button,
        .ant-menu-submenu-arrow {
          color: ${(props) => (props.theme.name === 'atsDark' ? '#fff' : 'inherit')};
        }
        background-color: transparent;
      }
      &.ant-menu-submenu:hover {
        .ant-menu-submenu-arrow {
          color: ${palette('foreground', 2)};
          transform: translateX(30%);
        }
      }
      &.ant-menu-item-active,
      &.ant-menu-submenu-active {
        &:hover {
          transform: translateX(8px);
          button {
            color: ${palette('foreground', 5)};
          }
        }
      }
    }
    &:not(.ant-menu-horizontal) .ant-menu-item-selected,
    &:not(.ant-menu-horizontal) .ant-menu-submenu-selected {
      background-color: ${palette('background', 30)};
      color: ${palette('background', 28)};
      border-left: ${palette('borderStyle', 1)};
      padding: ${palette('padding', 2)};
      .ant-menu-title-content {
        display: block;
        transition-duration: 250ms;
        transition-property: all;
        transition-timing-function: ease-out;
      }
      a,
      button {
        color: ${palette('foreground', 4)};
      }

      &.ant-menu-item-active,
      &.ant-menu-submenu-active {
        transform: translate(0);
        .ant-menu-title-content {
          transform: translate(8px);
        }
        a {
          color: ${palette('foreground', 4)};
        }
      }
    }
  }
  &.mini-sidebar {
    .ant-menu {
      .ant-menu-item,
      .ant-menu-submenu {
        button i,
        span i,
        span svg,
        .ant-menu-submenu-title.ant-menu-title-content button {
          margin: 0px 22px 0px 10px;
        }
      }
    }
  }
  @media only screen and (max-width: ${scaling125}) {
    .ant-menu {
      .ant-menu-item,
      .ant-menu-submenu {
        button i,
        span i,
        span svg {
          margin: 0px 22px 0px 10px;
        }
      }
    }
  }
`;

const MainPad = styled.div`
  padding: 0px ${palette('spacing', 0)}px 0px;
  background: ${palette('background', 37)};
  /* max-width: 1400px; */
  /* width: 100%; */
  position: absolute;
  bottom: ${palette('spacing', 0)}px;
  right: 0px;
  left: ${palette('size', 1)}px;
  top: ${(props) =>
    parseInt(props.theme.palette.spacing[0], 10) +
    parseInt(props.theme.palette.size[0], 10)}px; /* eslint-disable-line */

  ${LayoutWrapper}.mini-sidebar & {
    left: ${palette('size', 15)}px;
  }
  @media only screen and (max-width: ${scaling125}) {
    left: ${palette('size', 15)}px;
  }
  @media only screen and (max-width: ${hideMenu}) {
    padding: 0px 10px 0px;
    left: 0px !important;
    bottom: 0px;
  }
`;

const Absoluter = styled.span`
  position: absolute;
  z-index: 0;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
`;

const Overlay = styled.div`
  position: fixed;
  right: 0;
  left: 0;
  background-color: #000;
  opacity: 0;
  z-index: 3;
  visibility: hidden;
  height: 100%;
  height: 100vh;
  transition-duration: ${transitionDuration}ms;
  transform: translateZ(0);
  @media only screen and (max-width: ${hideMenu}) {
    &.expanded {
      visibility: visible;
      opacity: 0.3;
    }
  }
`;

const Header = styled.header`
  margin-left: ${palette('size', 1)}px;
  height: ${palette('size', 0)}px;
  display: block;
  background: ${palette('background', 2)};
  z-index: 2;
  position: fixed;
  top: 0px;
  left: 0;
  right: 0;
  border-bottom: ${palette('borderStyle', 0)};
  transition-duration: ${transitionDuration}ms;
  box-shadow: ${palette('shadowStyle', 23)};
  ${LayoutWrapper}.mini-sidebar & {
    margin-left: ${palette('size', 15)}px;
  }
  @media only screen and (max-width: ${scaling125}) {
    margin-left: ${palette('size', 15)}px;
  }
  @media only screen and (max-width: ${hideMenu}) {
    margin-left: 0px !important;
  }
  ${LayoutWrapper}.maximized & {
    display: none;
  }
`;

type AsideProps = {
  $hovered: boolean;
};

const Aside = styled.aside<AsideProps>`
  width: ${palette('size', 1)}px;
  height: 100%;
  height: 100vh;
  display: block;
  background: ${palette('background', 3)};
  position: fixed;
  top: 0px;
  padding-bottom: 20px;
  left: 0;
  z-index: 60;
  overflow: auto;
  overflow-x: hidden;
  transition-duration: ${transitionDuration}ms;
  transition-timing-function: ease-out;
  transform: translateZ(0);
  .ant-menu-item-divider {
    background-color: transparent !important;
    background: linear-gradient(to right, #2a4451, transparent);
    height: 1px;
    border: 0px;
    opacity: 0.3;
  }
  .new {
    background: orange;
    height: auto;
    font-size: 0.8rem;
    line-height: 0.8rem;
    padding: 4px;
    border-radius: 5px;
    margin-left: 6px;
    color: white;
  }
  ${collapsedAddButtonTransition}
  @media only screen and (min-width: 1441px) {
    ${LayoutWrapper}.mini-sidebar &:not(:hover) {
      ${collapsedAddButton}
    }
  }
  @media only screen and (min-width: 1441px) and (max-width: ${scaling125}) {
    &:not(:hover) {
      ${collapsedAddButton}
    }
  }
  @media only screen and (max-width: ${hideMenu}) {
    left: -260px;
    &.expanded {
      left: 0;
    }
  }
  &::-webkit-scrollbar {
    width: ${palette('size', 12)}px;
  }
  &::-webkit-scrollbar-thumb {
    background: transparent;
    transition-duration: 250ms;
  }
  &:hover {
    &::-webkit-scrollbar-thumb {
      background: ${palette('background', 71)};
    }
  }
  &::-webkit-scrollbar-track {
    background: transparent;
  }
  ${LayoutWrapper}.mini-sidebar & {
    width: ${palette('size', 15)}px;
    box-shadow: 0px 0px 10px #000000ad;

    &:hover {
      width: ${palette('size', 1)}px;
      @media only screen and (min-width: 1441px) {
        img {
          display: block !important;
          position: absolute;
          left: 50%;
          top: 9px;
          transform: translateX(-54%);
          animation: animateMainLogo 0.75s forwards;
          animation-delay: 0.25s;
          opacity: 0;

          @keyframes animateMainLogo {
            0% {
              opacity: 0;
            }

            100% {
              opacity: 1;
            }
          }

          &.scaled {
            transform: translateX(-50%);
            animation: animateScaledLogo 0.25s forwards;
            opacity: 1;

            @keyframes animateScaledLogo {
              0% {
                transform: scale(0.9);
              }

              100% {
                transform: scale(0);
              }
            }
          }
        }
      }
    }
  }
  @media only screen and (min-width: 1441px) and (max-width: 1538px) {
    .ant-menu {
      .ant-menu-submenu {
        &-arrow {
          display: none;
        }
      }
    }
    &:hover {
      img {
        display: block !important;
        position: absolute;
        left: 50%;
        top: 9px;
        transform: translateX(-54%);
        animation: animateMainLogo 0.75s forwards;
        animation-delay: 0.25s;
        opacity: 0;

        @keyframes animateMainLogo {
          0% {
            opacity: 0;
          }

          100% {
            opacity: 1;
          }
        }

        &.scaled {
          transform: translateX(-54%);
          animation: animateScaledLogo 0.25s forwards;
          opacity: 1;

          @keyframes animateScaledLogo {
            0% {
              transform: scale(0.9);
            }

            100% {
              transform: scale(0);
            }
          }
        }
      }
    }
  }

  @media only screen and (max-width: ${scaling125}) {
    box-shadow: 0px 0px 10px #000000ad !important;
    //Hover state needs to be handled via JS, because antsubmenu is not registered for hover effect because it is not inside of root
    width: ${(props) => (props.$hovered ? palette('size', 1) : palette('size', 15))}px !important;
  }

  @media only screen and (max-width: ${hideMenu}) {
    width: ${palette('size', 1)}px !important;
    box-shadow: none !important;
  }
  @media only screen and (max-width: ${breakAside}) {
    &::-webkit-scrollbar {
      width: ${palette('size', 13)}px;
    }
  }
  ${LayoutWrapper}.maximized & {
    display: none;
  }
`;

const MainStyled = styled.main`
  padding-top: ${palette('size', 0)}px;
  display: block;
  width: 100%;
  position: relative;
  padding-left: 240px;
  height: 100%;
  overflow: hidden;
  @media print {
    overflow: visible;
  }
  ${LayoutWrapper}.mini-sidebar & {
    padding-left: ${palette('size', 15)}px;
  }
  @media only screen and (max-width: ${scaling125}) {
    padding-left: ${palette('size', 15)}px;
  }
  @media only screen and (max-width: ${hideMenu}) {
    padding-left: 0px !important;
  }
  .text-row {
    border-radius: 40px;
  }
`;

const AsideHeader = styled.div`
  position: relative;
  height: 60px;
  background: ${palette('background', 27)};
  padding: 9px 11px;
  text-align: center;
  img.scaled {
    display: none;
    height: 33px;
  }
  ${LayoutWrapper}.mini-sidebar & {
    padding: 9px 5px;
    img {
      display: none;
      &.scaled {
        display: inline-block;
      }
    }
  }
  @media only screen and (max-width: ${scaling125}) {
    padding: 9px 5px;
    img {
      display: none;
      &.scaled {
        display: inline-block;
      }
    }
  }
  @media only screen and (max-width: ${hideMenu}) {
    padding: 9px 11px !important;
    img {
      display: inline-block !important;
      &.scaled {
        display: none !important;
      }
    }
  }
`;

const Logo = styled.img`
  height: 45px;
  margin-left: -18px;
  margin-top: 7px;
  ${(props) =>
    props.theme.name === 'atsDark' &&
    `
  filter: grayscale(1) brightness(3.5);
  `}
`;

const TransitionHolder = styled.section`
  position: absolute;
  width: 100%;
  left: 0;
  top: 0px;
  bottom: 0;
  right: 0;
  padding-left: ${palette('size', 1)}px;
  padding-top: ${(props) =>
    parseInt(props.theme.palette.spacing[0], 10) +
    parseInt(props.theme.palette.size[0], 10)}px; /* eslint-disable-line */
  ${LayoutWrapper}.mini-sidebar & {
    padding-left: ${palette('size', 15)}px;
  }
  @media only screen and (max-width: ${scaling125}) {
    padding-left: ${palette('size', 15)}px;
  }
  @media only screen and (max-width: ${hideMenu}) {
    padding-left: 0px !important;
  }
`;

const MainContent = styled.section`
  background: ${palette('background', 14)};
  overflow: auto;
  position: absolute;
  top: ${(props) =>
    parseInt(props.theme.palette.spacing[0], 10) +
    parseInt(props.theme.palette.size[0], 10)}px; /* eslint-disable-line */
  left: ${(props) =>
    parseInt(props.theme.palette.spacing[0], 10) +
    parseInt(props.theme.palette.size[1], 10)}px; /* eslint-disable-line */
  bottom: ${palette('spacing', 0)}px;
  right: ${palette('spacing', 0)}px;
  box-shadow: ${palette('shadowStyle', 3)};
  border-radius: 5px;
  &::-webkit-scrollbar {
    width: ${palette('size', 12)}px;
  }
  &::-webkit-scrollbar-thumb {
    background: ${palette('background', 71)};
  }
  &::-webkit-scrollbar-track {
    background: transparent;
  }

  &.removeShadow {
    box-shadow: none;
  }

  &.matchBorderRadius {
    border-radius: 10px 10px 0 0;
  }

  ${LayoutWrapper}.mini-sidebar & {
    left: ${(props) =>
      parseInt(props.theme.palette.spacing[0], 10) +
      parseInt(props.theme.palette.size[15], 10)}px; /* eslint-disable-line */
  }
  @media only screen and (max-width: ${scaling125}) {
    left: ${(props) =>
      parseInt(props.theme.palette.spacing[0], 10) +
      parseInt(props.theme.palette.size[15], 10)}px; /* eslint-disable-line */
  }
  @media only screen and (max-width: ${breakAside}) {
    &::-webkit-scrollbar {
      width: ${palette('size', 13)}px;
    }
  }
  @media only screen and (max-width: ${hideMenu}) {
    left: 0px !important;
    right: 0px;
    bottom: 0px;
    border-radius: 0px;
    box-shadow: none;
    top: ${(props) => parseInt(props.theme.palette.size[0], 10) + 15}px;
  }

  @media print {
    position: relative;
    top: auto;
    bottom: auto;
    left: auto;
    right: auto;
  }
`;

export {
  Absoluter,
  Aside,
  AsideHeader,
  Header,
  LayoutWrapper,
  Logo,
  MainContent,
  MainPad,
  MainStyled,
  Overlay,
  TransitionHolder,
};
